import React, {memo} from 'react'
import cx from 'classnames'

/* Styles */
import s from './price.scss'

const PriceSkeleton = memo(({
  className
}) => {
  return (
    <div className={cx(s.skeleton, className)} data-test-id={'price-skeleton'}>
      <div className={s.skeletonText}/>
      <div className={s.skeletonPrice}/>
    </div>
  )
})

export default PriceSkeleton
